import { render, staticRenderFns } from "./MatchDetail.vue?vue&type=template&id=1c50f6a9&scoped=true"
import script from "./MatchDetail.vue?vue&type=script&lang=js"
export * from "./MatchDetail.vue?vue&type=script&lang=js"
import style0 from "./MatchDetail.vue?vue&type=style&index=0&id=1c50f6a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c50f6a9",
  null
  
)

export default component.exports